import { CommonModule } from '@angular/common';
import { compararValoresOrdenacao } from '@shared/helpers/ordenacao-tabela.helper';
import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule, Sort, SortDirection } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDrag, CdkDragDrop, CdkDragStart, CdkDropList, CdkDropListGroup, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Observable, Subject, firstValueFrom, forkJoin, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, map, switchMap, takeUntil } from 'rxjs/operators';
import { MatDividerModule } from '@angular/material/divider';
import { ConfirmModalComponent } from '@shared/components/confirm-modal/confirm-modal.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { EmptyListComponent } from '@shared/components/empty-list/empty-list.component';
import { LoadingBoxComponent } from '@shared/components/loading-box/loading-box.component';
import { LoadingBoxDefaultListComponent } from '@shared/components/loading-box-default-list/loading-box-default-list.component';
import { CardEditDialogComponent } from './dialogs/card-edit-dialog/card-edit-dialog.component';
import {
  CardNotaContexto,
  ETAPAS_FINALIZACAO_SEM_NF,
  fmtMoneyDisplay,
  formatCodigoCompra,
  formatKanbanCardValue,
  parseBR,
  rotuloNotaFiscal,
} from './dialogs/card-edit-dialog/card-edit-dialog.types';
import { NovaSolicitacaoDialogComponent } from './dialogs/nova-solicitacao-dialog/nova-solicitacao-dialog.component';
import { GavetaNfsComponent } from './panels/gaveta-nfs/gaveta-nfs.component';
import { VinculoNotaPedidoFluxoService } from './services/vinculo-nota-pedido-fluxo.service';
import { FinalizacaoCompraFluxoService } from './services/finalizacao-compra-fluxo.service';
import { VincularNotaPedidoDialogComponent, VincularNotaPedidoDialogData, VincularNotaPedidoDialogResult } from './dialogs/vincular-nota-pedido-dialog/vincular-nota-pedido-dialog.component';
import { NotaFiscalEntradaService } from '@shared/services/apis/orquestrador-compras/nota-fiscal-entrada.service';
import { CompraNotaFiscalEntradaStruct } from '@shared/services/structs/orquestrador-compras/compra-nota-fiscal-entrada.struct';
import { MovimentacaoJustificativaDialogComponent } from './dialogs/movimentacao-justificativa-dialog/movimentacao-justificativa-dialog.component';
import { AssociarProdutosAvulsosDialogComponent, AssociarProdutosAvulsosDialogData, AssociarProdutosAvulsosDialogResult } from './dialogs/associar-produtos-avulsos-dialog/associar-produtos-avulsos-dialog.component';
import { FuncionalidadeEnum } from '@shared/enums/usuario/funcionalidade.enum';
import { PermissaoEnum } from '@shared/enums/usuario/permissao.enum';
import { ModuloEnum } from '@shared/enums/usuario/modulo.enum';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { CompraService, ComprasFiltroParams } from '@shared/services/apis/compras/compra.service';
import { CompraEtapaService } from '@shared/services/apis/compras/compra-etapa.service';
import { OrquestradorCompraEtapaService } from '@shared/services/apis/orquestrador-compras/compra-etapa.service';
import { AutomacaoService } from '@shared/services/apis/compras/automacao.service';
import { TipoOcorrenciaCompraEnum } from '@shared/enums/compras/tipo-ocorrencia-compra.enum';
import { EtapasKanbanService } from '@shared/services/apis/compras/etapas-kanban.service';
import { MovimentarCompraEtapaRequest } from '@shared/services/requests/compras/movimentar-compra-etapa.request';
import { PerfilUsuarioVinculoRequest } from '@shared/services/requests/compras/perfil-usuario-vinculo.request';
import { AuthService } from '@shared/services/apis/usuario/auth.service';
import { UsuarioService } from '@shared/services/apis/usuario/usuario.service';
import { PessoaLookupService } from '@shared/services/apis/pessoa/pessoa-lookup.service';
import { UtilService } from '@shared/services/util.service';
import { EtapaKanbanStruct } from '@shared/services/structs/compras/etapa-kanban.struct';
import { DetalheCompraResponse } from '@shared/services/responses/compras/detalhe-compra.response';
import { CompraKanbanEtapaGrupo } from '@shared/services/structs/compras/compra-kanban-etapa-grupo.struct';
import { CompraKanbanStruct } from '@shared/services/structs/compras/compra-kanban.struct';
import { StatusCancelamentoCompraEnum } from '@shared/enums/compras/status-cancelamento-compra.enum';
import { StatusConferenciaEnum } from '@shared/enums/compras/status-conferencia.enum';
import { TipoConferenciaEnum } from '@shared/enums/compras/tipo-conferencia.enum';
import { MovimentarCompraEtapaResponse } from '@shared/services/responses/compras/movimentar-compra-etapa.response';
import { CompraLancamentoFinalizacaoStruct } from '@shared/services/structs/compras/compra-lancamento-finalizacao.struct';
import { BulkCancelarCompraItemResultStruct } from '@shared/services/structs/compras/bulk-cancelar-compra-item-result.struct';
import { UsuarioListaStruct } from '@shared/services/structs/usuario/usuario-lista.struct';
import { TipoPrioridadeEnum } from '@shared/enums/compras/tipo-prioridade.enum';
import { TipoIntegracaoEnum, TipoIntegracaoIndicador } from '@shared/enums/compras/tipo-integracao.enum';
import { KanbanCard, KanbanStage, Person } from './processo-compras.models';

/** Etapas antes do pedido têm título próprio; da etapa Pedido de Compra em diante o card é sempre "Pedido". */
const TITULO_POR_ETAPA: Record<string, string> = {
  solicitacao: 'Solicitação',
  cotacao: 'Cotação',
};

const AVATAR_COLORS = ['#B73232', '#1E5DB8', '#1E8E3E', '#7A4FBF', '#C26A00', '#0F7A8B'];

const PRIO_CONFIG: Record<string, { color: string; label: string }> = {
  alta:  { color: '#F44336', label: 'Alta' },
  media: { color: '#FFC107', label: 'Média' },
  baixa: { color: '#4CAF50', label: 'Baixa' },
};

const PRIO_POR_ID: Record<number, 'alta' | 'media' | 'baixa'> = {
  [TipoPrioridadeEnum.Baixa]: 'baixa',
  [TipoPrioridadeEnum.Media]: 'media',
  [TipoPrioridadeEnum.Alta]: 'alta',
};
const ID_POR_PRIO: Record<string, number> = {
  baixa: TipoPrioridadeEnum.Baixa,
  media: TipoPrioridadeEnum.Media,
  alta: TipoPrioridadeEnum.Alta,
};

const ETAPA_DESCONHECIDA: KanbanStage = {
  key: '',
  icon: 'help',
  name: 'Sem etapa',
  color: '#9AA0A6',
  tint: '#9AA0A622',
};

interface EtapaPageState {
  paginaAtual: number;
  carregando: boolean;
  temMais: boolean;
  totalRegistros: number;
  somaValor: number;
  carregadaAlgumaVez: boolean;
  token: number;
}

const ESTADO_ETAPA_VAZIO: EtapaPageState = {
  paginaAtual: 0, carregando: false, temMais: false,
  totalRegistros: 0, somaValor: 0, carregadaAlgumaVez: false, token: 0,
};

/** Índice no array da etapa de origem (não o índice renderizado: nas etapas com NF os cards ficam agrupados). */
interface MoveContext {
  previousContainerData: KanbanCard[];
  currentContainerData: KanbanCard[];
  previousIndex: number;
}

/** Etapas em que os pedidos aparecem agrupados sob a NF vinculada (moldura mesmo com um pedido só). */
const ETAPAS_AGRUPADAS_POR_NF = new Set(['faturado', 'conferencia', 'finalizado', 'divergencia']);

/** Grupo renderizado na coluna: moldura da NF (`isGrupo`) ou um card solto. */
interface GrupoCardsEtapa {
  chave: string;
  idNFeEntrada: number | null;
  isGrupo: boolean;
  rotulo: string;
  pedidosLabel: string;
  totalLabel: string;
  cards: KanbanCard[];
}


interface MoveStrategy {
  rollback: () => void;
  confirmar: (confirmedStage: string) => void;
}

// Fallback usado só até as movimentações configuradas chegarem do backend (effectiveTransitions).
// Espelha a grade do seed.
const TRANSITIONS: Record<string, string[]> = {
  solicitacao: ['cotacao', 'pedido', 'cancelado'],
  cotacao:     ['pedido', 'solicitacao', 'cancelado'],
  pedido:      ['aprovacao', 'cotacao', 'faturado', 'cancelado'],
  aprovacao:   ['faturado', 'pedido', 'cotacao', 'solicitacao', 'cancelado'],
  faturado:    ['conferencia', 'finalizado'],
  conferencia: ['finalizado', 'divergencia'],
  finalizado:  [],
  cancelado:   [],
  divergencia: ['conferencia', 'finalizado'],
};

@Component({
  selector: 'app-processo-compras',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatBadgeModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDividerModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    HeaderComponent,
    EmptyListComponent,
    LoadingBoxComponent,
    LoadingBoxDefaultListComponent,
    CdkDropList,
    CdkDropListGroup,
    CdkDrag,
    GavetaNfsComponent,
  ],
  templateUrl: './processo-compras.component.html',
  styleUrl: './processo-compras.component.css',
})
export class ProcessoComprasComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly moduloEnum = ModuloEnum.Suprimentos;
  readonly funcionalidadeEnum = FuncionalidadeEnum.Suprimentos_ProcessoCompras;
  readonly listPageSize = 20;
  readonly kanbanPageSize = 10;

  activeTab: 'kanban' | 'lista' = 'kanban';
  conteudoViewportAtivo = false;

  /** Gaveta de NFs — o painel se carrega sozinho e devolve o total para o contador do botão. */
  gavetaAberta = false;
  gavetaTotal = 0;

  @ViewChild('tabBtnKanban') private tabBtnKanban?: ElementRef<HTMLElement>;
  @ViewChild('tabBtnLista') private tabBtnLista?: ElementRef<HTMLElement>;
  @ViewChild('boardWrapper') private boardWrapper?: ElementRef<HTMLElement>;
  @ViewChild(GavetaNfsComponent) private gaveta?: GavetaNfsComponent;
  indicadorX = 0;
  indicadorW = 0;

  readonly skeletonCards = [1, 2, 3];
  /** Colunas fantasma enquanto as etapas não chegam (sem etapa, não há coluna para preencher). */
  readonly skeletonColumns = [1, 2, 3, 4, 5];
  etapasCarregando = true;

  // Lista view — mat-table real (matSort + mat-checkbox), como o resto do sistema.
  readonly listDisplayedColumns: string[] = ['select', 'id', 'title', 'stage', 'resp', 'prio', 'date', 'status', 'integracoes', 'value', 'actions'];
  listSelection = new SelectionModel<KanbanCard>(true, []);
  acoesLoading = false;
  listSortActive = 'id';
  listSortDirection: SortDirection = 'desc';

  filterModel = this.fb.group({
    searchText: [''],
    filterRespId: [null as number | null],
    filterPrio: [''],
    filterStage: [''],
    filterStatus: [''],
  });

  private appliedFilters = {
    searchText: '',
    filterRespId: null as number | null,
    filterPrio: '',
    filterStage: '',
    filterStatus: '',
  };

  mainStages: KanbanStage[] = [];
  sideStages: KanbanStage[] = [];
  allStages: KanbanStage[] = [];
  prioConfig = PRIO_CONFIG;

  collapsedStages = new Set<string>(['cancelado', 'divergencia']);

  cardsByStage: Record<string, KanbanCard[]> = {};
  private etapaPages: Record<string, EtapaPageState> = {};
  private kanbanToken = 0;

  /** NF com vínculo ativo por idCompra, para agrupar os cards das etapas com NF. Limpo a cada recarga do quadro. */
  private notasPorCompra = new Map<number, CompraNotaFiscalEntradaStruct>();
  private notasToken = 0;
  /** Nome do fornecedor por idFornecedor (o Compras só guarda o id). Mantido entre recargas: o nome não muda com o quadro. */
  private nomesFornecedor = new Map<number, string>();
  private idsFornecedorSolicitados = new Set<number>();
  /** NF cujo "Gerenciar vínculo" está em andamento (impede abrir dois fluxos). */
  gerenciandoNotaId: number | null = null;
  /** Mesma permissão que o vincularItens exige no backend; master passa sempre, como no restante da UI. */
  podeGerenciarVinculoNota = false;
  readonly semPermissaoGerenciarVinculo = 'Você não tem permissão para alterar o Processo de Compras.';
  /** Mesma permissão que o backend exige para cancelar (arraste para Cancelado e menu); master passa sempre. */
  podeCancelarCompra = false;
  readonly semPermissaoCancelarCompra = 'Seu perfil não tem permissão para cancelar compras.';
  /** Tooltip dos cards com o arraste desligado (`hasActiveFilters`). */
  readonly motivoArrasteBloqueado = 'Limpe a pesquisa e os filtros para mover os cards entre as etapas.';

  private listaCards: KanbanCard[] = [];
  paginatedCards: KanbanCard[] = [];
  listaTotalRegistros = 0;
  listaUltimaPagina = true;
  listaCarregando = false;
  private listaPaginaAtual = 0;
  private listaToken = 0;
  private listaDesatualizada = true;

  draggedCard: KanbanCard | null = null;
  /**
   * Pedido sob o ponteiro no início do arraste — o que o drop usa. Separado de `draggedCard` porque o
   * `ended` do CDK (que o zera) chega antes do `dropped`.
   */
  private cardAgarrado: KanbanCard | null = null;
  /** Etapa com NF sob o card arrastado de outra coluna: mostra o espaço no topo, fora das molduras. */
  etapaSlotTopo: string | null = null;
  alturaCardArrastado = 0;
  suppressCardMoveAnimation = false;

  private usersById = new Map<number, Person>();
  peopleList: Person[] = [];
  private openingCardKeys = new Set<string>();
  private loadingCardKeys = new Set<string>();

  private destroy$ = new Subject<void>();

  /** Compra pedida pela URL (?idCompra=), aberta quando as etapas carregam. */
  private acaoUrlPendente: { idCompra: number | null } | null = null;

  // Movimentações vindas da config do backend (etapa_kanban_movimentacao).
  // Caem para o mapa estático TRANSITIONS enquanto não carregam (ou se a empresa não configurou nada).
  private dynamicTransitions: Record<string, string[]> = {};
  private transitionsLoaded = false;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private etapasKanbanService: EtapasKanbanService,
    private compraService: CompraService,
    private compraEtapaService: CompraEtapaService,
    private orquestradorCompraEtapaService: OrquestradorCompraEtapaService,
    private automacaoService: AutomacaoService,
    private authService: AuthService,
    private usuarioService: UsuarioService,
    private pessoaLookupService: PessoaLookupService,
    private alertService: AlertService,
    private utilService: UtilService,
    private notaFiscalEntradaService: NotaFiscalEntradaService,
    private vinculoNotaPedidoFluxo: VinculoNotaPedidoFluxoService,
    private finalizacaoFluxo: FinalizacaoCompraFluxoService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const usuario = this.authService.getUserInfos();
    this.podeGerenciarVinculoNota = !!usuario?.master
      || !!usuario?.listaPermissoes?.includes(PermissaoEnum.Suprimentos_ProcessoCompras_Alterar);
    this.podeCancelarCompra = !!usuario?.master
      || !!usuario?.listaPermissoes?.includes(PermissaoEnum.Suprimentos_ProcessoCompras_Excluir);
    this.loadFilters();
    this.lerParametrosUrl();
    this.assinarBuscaDebounced();
    this.carregarEtapas();
    this.carregarMovimentacoes();
  }

  /** ?idCompra= (consulta de últimas compras do cadastro de Pessoa): abre o card depois que as etapas carregam. */
  private lerParametrosUrl(): void {
    const params = this.route.snapshot.queryParamMap;
    if (!params.has('idCompra')) return;

    const idCompra = Number(params.get('idCompra'));
    this.acaoUrlPendente = { idCompra: Number.isInteger(idCompra) && idCompra > 0 ? idCompra : null };
  }

  /** Chamado quando as etapas terminam de carregar: o card precisa da etapa da compra para abrir. */
  private executarAcaoUrl(): void {
    if (!this.acaoUrlPendente || this.etapasCarregando) return;

    const { idCompra } = this.acaoUrlPendente;
    this.acaoUrlPendente = null;

    if (idCompra) this.abrirCompraPorId(idCompra);

    this.limparParametrosUrl();
  }

  private limparParametrosUrl(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { idCompra: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  ngAfterViewInit(): void {
    // setTimeout e não direto no hook: escrever em indicadorX/W durante o
    // AfterViewInit dispararia "changed after it was checked" em modo dev.
    setTimeout(() => {
      this.posicionarIndicadorAbas();
      this.atualizarScrollDoConteudo();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.filterModel, [
      '/suprimentos/processo-compras',
    ]);
  }

  private assinarBuscaDebounced(): void {
    this.filterModel.controls.searchText.valueChanges.pipe(
      debounceTime(350),
      map(valor => (valor ?? '').trim()),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
    ).subscribe(termo => {
      if (termo === this.appliedFilters.searchText) return;
      this.appliedFilters = { ...this.appliedFilters, searchText: termo };
      this.recarregarKanban();
      this.invalidarLista();
    });
  }

  private loadFilters(): void {
    const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
    if (!filtroSalvo) return;

    const statusValido = this.statusFiltroOpcoes.some(o => o.value === filtroSalvo.filterStatus);
    const restaurado = {
      ...filtroSalvo,
      filterStatus: statusValido ? filtroSalvo.filterStatus : '',
    };

    this.filterModel.patchValue(restaurado, { emitEvent: false });
    this.snapshotFiltros();
  }

  private carregarEtapas(): void {
    this.etapasCarregando = true;
    this.etapasKanbanService.getAll('', false).subscribe({
      next: (response) => {
        this.etapasCarregando = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription || 'Não foi possível carregar as etapas do kanban.', AlertType.error);
          this.aplicarEtapas([]);
          return;
        }
        this.aplicarEtapas(response.listaEtapas ?? []);
        this.carregarCards();
        this.executarAcaoUrl();
      },
      error: () => {
        this.etapasCarregando = false;
        this.alertService.show('Erro', 'Não foi possível carregar as etapas do kanban.', AlertType.error);
        this.aplicarEtapas([]);
      },
    });
  }

  /** Carrega as movimentações configuradas (etapa_kanban_movimentacao) para dirigir as transições. A justificativa é pedida pelo PUT. */
  private carregarMovimentacoes(): void {
    this.etapasKanbanService.listarMovimentacoes().subscribe({
      next: (res) => {
        // Mantém o fallback estático quando a config não carrega; o PUT continua validando cada movimento.
        if (res.isError) {
          this.alertService.show('Erro',
            res.errorDescription || 'Não foi possível carregar as movimentações das etapas.', AlertType.error);
          return;
        }
        const lista = res.lista ?? [];
        // Lista vazia = empresa ainda sem movimentações provisionadas (ou corrida com o seed):
        // mantém o fallback estático em vez de bloquear todos os movimentos.
        if (lista.length === 0) return;
        const map: Record<string, string[]> = {};
        for (const m of lista) {
          (map[m.origemChave] ??= []).push(m.destinoChave);
        }
        this.dynamicTransitions = map;
        this.transitionsLoaded = true;
      },
      error: () => this.alertService.show('Erro', 'Não foi possível carregar as movimentações das etapas.', AlertType.error),
    });
  }

  /** Transições efetivas: config do backend quando disponível, senão o mapa estático. */
  private get effectiveTransitions(): Record<string, string[]> {
    return this.transitionsLoaded ? this.dynamicTransitions : TRANSITIONS;
  }

  private montarFiltros(): ComprasFiltroParams {
    const { searchText, filterRespId, filterPrio, filterStage, filterStatus } = this.appliedFilters;
    return {
      pesquisa: searchText || null,
      idUsuarioResponsavel: filterRespId,
      idTipoPrioridade: filterPrio ? (ID_POR_PRIO[filterPrio] ?? null) : null,
      status: filterStatus || null,
      chaveEtapa: filterStage || null,
    };
  }

  private carregarCards(): void {
    const token = ++this.kanbanToken;
    forkJoin({
      kanban: this.compraService.getKanban(this.montarFiltros(), this.kanbanPageSize),
      usuarios: this.usuarioService.getAll(),
    }).subscribe({
      next: ({ kanban, usuarios }) => {
        if (token !== this.kanbanToken) return;
        if (usuarios.isError) {
          this.alertService.show('Erro', usuarios.errorDescription || 'Não foi possível carregar os usuários.', AlertType.error);
        } else {
          this.mapearUsuarios(usuarios.listaUsuario || []);
        }

        if (kanban.isError) {
          this.alertService.show('Erro', kanban.errorDescription || 'Não foi possível carregar as compras do kanban.', AlertType.error);
          return;
        }

        this.aplicarKanbanPaginado(kanban.etapas ?? []);
        this.carregarNotasDasEtapas();
        this.carregarNomesFornecedores(Object.values(this.cardsByStage).flat());
        this.colapsarEtapasSemAcesso();
      },
      error: () => {
        if (token !== this.kanbanToken) return;
        this.alertService.show('Erro', 'Não foi possível carregar as compras do kanban.', AlertType.error);
      },
    });
  }

  private recarregarKanban(): void {
    if (!this.allStages.length) return;
    // Trocar NF muda a nota dos pedidos: o mapa é refeito e resposta atrasada da carga anterior é descartada.
    this.notasPorCompra = new Map();
    this.notasToken++;
    this.carregarCards();
  }

  /**
   * Busca, numa chamada só, a NF dos cards das etapas com NF que ainda não estão no mapa. Até a
   * resposta (ou em caso de erro, avisado por toast) os cards aparecem soltos.
   */
  private carregarNotasDasEtapas(): void {
    const idsCompra = [...new Set(
      [...ETAPAS_AGRUPADAS_POR_NF]
        .flatMap(chave => this.cardsByStage[chave] ?? [])
        .map(card => card.idCompra)
        .filter((id): id is number => !!id && !this.notasPorCompra.has(id)),
    )];
    if (!idsCompra.length) return;

    const token = this.notasToken;
    this.notaFiscalEntradaService.notasPorCompras(idsCompra).subscribe({
      next: (res) => {
        if (token !== this.notasToken) return;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription || 'Não foi possível carregar as NF-es dos pedidos.', AlertType.error);
          return;
        }
        for (const nota of res.lista ?? []) {
          // Pedido com mais de uma NF ativa fica no grupo da primeira (menor vínculo), como no protótipo.
          const atual = this.notasPorCompra.get(nota.idCompra);
          if (!atual || nota.idCompraNFeEntradaVinculo < atual.idCompraNFeEntradaVinculo) {
            this.notasPorCompra.set(nota.idCompra, nota);
          }
        }
      },
      error: () => {
        if (token !== this.notasToken) return;
        this.alertService.show('Erro', 'Não foi possível carregar as NF-es dos pedidos.', AlertType.error);
      },
    });
  }

  /** Busca, numa chamada só, o nome dos fornecedores dos cards que ainda não foram pedidos. */
  private carregarNomesFornecedores(cards: KanbanCard[]): void {
    const ids = [...new Set(
      cards
        .map(card => card.idFornecedor)
        .filter((id): id is number => !!id && !this.idsFornecedorSolicitados.has(id)),
    )];
    if (!ids.length) return;

    ids.forEach(id => this.idsFornecedorSolicitados.add(id));
    this.pessoaLookupService.getListPessoaIds({ listIdPessoa: ids }).subscribe({
      next: (res) => {
        if (res.isError) {
          ids.forEach(id => this.idsFornecedorSolicitados.delete(id));
          this.alertService.show('Erro', res.errorDescription || 'Não foi possível carregar os fornecedores.', AlertType.error);
          return;
        }
        for (const p of res.listaPessoa || []) {
          this.nomesFornecedor.set(p.idPessoa, p.nome || p.nomeFantasia || '');
        }
      },
      error: () => {
        ids.forEach(id => this.idsFornecedorSolicitados.delete(id));
        this.alertService.show('Erro', 'Não foi possível carregar os fornecedores.', AlertType.error);
      },
    });
  }

  nomeFornecedor(card: KanbanCard): string {
    return card.idFornecedor ? this.nomesFornecedor.get(card.idFornecedor) || '' : '';
  }

  private mapearUsuarios(usuarios: UsuarioListaStruct[]): void {
    const pessoas = usuarios.filter(u => u.ativo && !u.deletado);
    this.usersById = new Map(
      pessoas.map((u, i) => [
        u.idUsuario,
        {
          idUsuario: u.idUsuario,
          name: u.nomeUsuario,
          initials: this.derivarIniciais(u.nomeUsuario),
          color: AVATAR_COLORS[i % AVATAR_COLORS.length],
        },
      ])
    );
    this.peopleList = [...this.usersById.values()].sort((a, b) => compararValoresOrdenacao(a.name, b.name));
  }

  private aplicarKanbanPaginado(etapas: CompraKanbanEtapaGrupo[]): void {
    const novosCards: Record<string, KanbanCard[]> = {};
    const novosEstados: Record<string, EtapaPageState> = {};
    this.allStages.forEach(s => {
      novosCards[s.key] = [];
      novosEstados[s.key] = { ...this.novoEstadoEtapa(), carregadaAlgumaVez: true };
    });

    for (const grupo of etapas) {
      if (!grupo.chaveEtapa || !novosEstados[grupo.chaveEtapa]) continue;
      novosCards[grupo.chaveEtapa] = (grupo.cards ?? []).map(c => this.mapCard(c));
      novosEstados[grupo.chaveEtapa] = {
        paginaAtual: 0,
        carregando: false,
        temMais: grupo.temMais,
        totalRegistros: grupo.totalRegistros,
        somaValor: grupo.somaValorTotal,
        carregadaAlgumaVez: true,
        token: 0,
      };
    }

    this.cardsByStage = novosCards;
    this.etapaPages = novosEstados;
  }

  private novoEstadoEtapa(): EtapaPageState {
    return { paginaAtual: 0, carregando: false, temMais: false, totalRegistros: 0, somaValor: 0, carregadaAlgumaVez: false, token: 0 };
  }

  etapaEstado(stageKey: string): EtapaPageState {
    return this.etapaPages[stageKey] ?? ESTADO_ETAPA_VAZIO;
  }

  totalDaEtapa(stageKey: string): number {
    return this.etapaEstado(stageKey).totalRegistros;
  }

  private resetarEtapa(chaveEtapa: string | null | undefined): void {
    if (!chaveEtapa) return;
    if (!this.etapaPages[chaveEtapa]) return;
    this.buscarPaginaEtapa(chaveEtapa, 0, true);
  }

  private resetarEtapas(chaves: (string | null | undefined)[]): void {
    new Set(chaves.filter((c): c is string => !!c)).forEach(c => this.resetarEtapa(c));
  }

  carregarMaisDaEtapa(stageKey: string): void {
    const estado = this.etapaPages[stageKey];
    if (!estado || estado.carregando || !estado.temMais) return;
    this.buscarPaginaEtapa(stageKey, estado.paginaAtual + 1, false);
  }

  private buscarPaginaEtapa(chaveEtapa: string, pagina: number, substituir: boolean): void {
    const estado = this.etapaPages[chaveEtapa];
    if (!estado) return;

    const token = ++estado.token;
    estado.carregando = true;

    this.compraService.getKanbanEtapa(chaveEtapa, this.montarFiltros(), pagina, this.kanbanPageSize).subscribe({
      next: (res) => {
        if (token !== estado.token || this.etapaPages[chaveEtapa] !== estado) return;
        estado.carregando = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription || 'Não foi possível carregar as compras da etapa.', AlertType.error);
          return;
        }

        const cards = (res.cards ?? []).map(c => this.mapCard(c));
        this.carregarNomesFornecedores(cards);
        const trocar = substituir || !estado.carregadaAlgumaVez;
        this.cardsByStage[chaveEtapa] = trocar ? cards : [...(this.cardsByStage[chaveEtapa] ?? []), ...cards];
        this.cardsByStage = { ...this.cardsByStage };

        estado.paginaAtual = res.pagina ?? pagina;
        estado.temMais = res.temMais;
        estado.totalRegistros = res.totalRegistros;
        estado.somaValor = res.somaValorTotal;
        estado.carregadaAlgumaVez = true;
        if (ETAPAS_AGRUPADAS_POR_NF.has(chaveEtapa)) this.carregarNotasDasEtapas();
      },
      error: () => {
        if (token !== estado.token || this.etapaPages[chaveEtapa] !== estado) return;
        estado.carregando = false;
        this.alertService.show('Erro', 'Não foi possível carregar as compras da etapa.', AlertType.error);
      },
    });
  }

  /** Etapas sem Visualizar para o perfil e sem nenhum card do responsável começam colapsadas. */
  private colapsarEtapasSemAcesso(): void {
    this.allStages.forEach(s => {
      if (s.podeVisualizar === false && this.totalDaEtapa(s.key) === 0) {
        this.collapsedStages.add(s.key);
      }
    });
  }

  private mapCard(c: CompraKanbanStruct): KanbanCard {
    const pessoa = c.idUsuarioResponsavel ? this.usersById.get(c.idUsuarioResponsavel) : undefined;
    const dt = new Date(c.datetimeInclusao);
    return {
      id: formatCodigoCompra(c.codigo),
      idCompra: c.idCompra,
      idUsuarioResponsavel: c.idUsuarioResponsavel,
      stage: c.chaveEtapa,
      title: c.titulo ?? '',
      idFornecedor: c.idFornecedor,
      qtdFornecedores: c.qtdFornecedores,
      qtdFornecedoresResponderam: c.qtdFornecedoresResponderam,
      value: formatKanbanCardValue(c.valorTotal),
      prio: PRIO_POR_ID[c.idTipoPrioridade] || 'media',
      resp: pessoa?.initials || '',
      respName: pessoa?.name,
      respColor: pessoa?.color,
      date: dt.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }),
      isAprovado: c.isAprovado,
      idStatusConferenciaVolumes: c.idStatusConferenciaVolumes,
      idStatusConferenciaItens: c.idStatusConferenciaItens,
      quantidadeProblemasConferencia: c.quantidadeProblemasConferencia,
      quantidadeDivergenciasConferencia: c.quantidadeDivergenciasConferencia,
      isEstoqueLancado: c.isEstoqueLancado,
      isFinanceiroLancado: c.isFinanceiroLancado,
      idOrigemLancamentoEstoque: c.idOrigemLancamentoEstoque,
      idOrigemLancamentoFinanceiro: c.idOrigemLancamentoFinanceiro,
      isSemNotaFiscal: c.isSemNotaFiscal,
      updatedAt: dt.getTime(),
    };
  }

  private derivarIniciais(nome: string): string {
    const partes = (nome || '').trim().split(/\s+/).filter(Boolean);
    if (!partes.length) return '?';
    if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
    return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
  }

  private aplicarEtapas(etapas: EtapaKanbanStruct[]): void {
    const normalizadas = etapas
      .filter(etapa => etapa.isAtivo)
      .map(etapa => this.mapEtapa(etapa))
      .sort((a, b) => a.ordem - b.ordem || compararValoresOrdenacao(a.name, b.name));

    this.mainStages = normalizadas.filter(etapa => !etapa.isEspecial);
    this.sideStages = normalizadas.filter(etapa => etapa.isEspecial);
    this.allStages = [...this.mainStages, ...this.sideStages];
    this.initCards();
    this.sanearEtapaFiltrada();
  }

  private sanearEtapaFiltrada(): void {
    const chave = this.appliedFilters.filterStage;
    if (!chave || this.allStages.some(s => s.key === chave)) return;
    this.filterModel.patchValue({ filterStage: '' }, { emitEvent: false });
    this.appliedFilters = { ...this.appliedFilters, filterStage: '' };
  }

  private mapEtapa(etapa: EtapaKanbanStruct): KanbanStage & { ordem: number; isEspecial: boolean } {
    const color = etapa.cor || '#1E5DB8';
    return {
      key: etapa.chave,
      icon: etapa.icone || 'description',
      name: etapa.nome,
      color,
      tint: `${color}22`,
      idEtapaKanban: etapa.idEtapaKanban,
      podeVisualizar: etapa.podeVisualizar,
      ordem: etapa.ordem,
      isEspecial: etapa.isEspecial,
      isFinal: etapa.isFinal,
      // Mesmo critério do modal de configuração da etapa: só Aberta explícita não é cega.
      isConferenciaCega: etapa.idTipoConferenciaVolumes !== TipoConferenciaEnum.Aberta
        || etapa.idTipoConferenciaItens !== TipoConferenciaEnum.Aberta,
    };
  }

  private initCards(): void {
    const cardsAtuais = this.cardsByStage;
    const estadosAtuais = this.etapaPages;
    this.cardsByStage = {};
    this.etapaPages = {};
    this.allStages.forEach(s => {
      this.cardsByStage[s.key] = cardsAtuais[s.key] || [];
      this.etapaPages[s.key] = estadosAtuais[s.key] || this.novoEstadoEtapa();
    });
  }

  getStage(key: string): KanbanStage {
    return this.allStages.find(s => s.key === key) || ETAPA_DESCONHECIDA;
  }

  canDrop(card: KanbanCard, toStage: string): boolean {
    if (card.stage === toStage) return true;
    if (toStage === 'cancelado' && !this.podeCancelarCompra) return false;
    // Pedido sem NF-e vai direto para Finalizado, mesmo fora das movimentações configuradas.
    if (toStage === 'finalizado' && card.isSemNotaFiscal && ETAPAS_FINALIZACAO_SEM_NF.has(card.stage)) return true;
    return (this.effectiveTransitions[card.stage] || []).includes(toStage);
  }

  /** Etapa em que os cards aparecem agrupados pela NF (a ordem renderizada deixa de ser a do array). */
  isEtapaAgrupadaPorNf(stageKey: string): boolean {
    return ETAPAS_AGRUPADAS_POR_NF.has(stageKey);
  }

  drop(event: CdkDragDrop<KanbanCard[]>, toStageKey: string): void {
    this.etapaSlotTopo = null;
    // Na moldura da NF o cdkDrag é a moldura e o dado é o primeiro pedido; o agarrado é o que vale.
    const card: KanbanCard = this.cardAgarrado ?? event.item.data;
    this.cardAgarrado = null;
    // Índices do CDK seguem a ordem renderizada; nas etapas com NF ela difere do array.
    const indiceOrigem = event.previousContainer.data.indexOf(card);
    if (event.previousContainer === event.container) {
      // Nas etapas com NF a ordenação está desligada (reordenar não tem efeito no backend).
      if (!this.isEtapaAgrupadaPorNf(toStageKey) && indiceOrigem >= 0) {
        moveItemInArray(event.container.data, indiceOrigem, event.currentIndex);
      }
      this.draggedCard = null;
      return;
    }
    if (!this.canDrop(card, toStageKey) || indiceOrigem < 0) {
      this.draggedCard = null;
      return;
    }

    const fromStageKey = card.stage;

    // Card de uma moldura de NF com mais de um pedido: o grupo inteiro vai junto (tudo ou nada).
    // Cancelar continua individual; card sozinho na moldura ou etapa sem NF seguem o fluxo de um card.
    const nota = card.idCompra ? this.notasPorCompra.get(card.idCompra) : undefined;
    const cardsDaNota = nota && this.isEtapaAgrupadaPorNf(fromStageKey) && toStageKey !== 'cancelado'
      ? this.cardsDaNotaParaMover(nota.idNFeEntrada, fromStageKey, toStageKey)
      : [];
    if (cardsDaNota.length > 1) {
      this.draggedCard = null;
      // Pedidos da NF em outras colunas (só para Finalizado) não estão na moldura arrastada: confirma antes.
      if (cardsDaNota.every(c => c.stage === fromStageKey)) {
        this.moverGrupoDaNota(cardsDaNota, fromStageKey, toStageKey, event.container.data);
      } else {
        this.confirmarMoverGrupoDaNota(cardsDaNota, card.idCompra!).subscribe(isConfirmado => {
          if (isConfirmado) this.moverGrupoDaNota(cardsDaNota, fromStageKey, toStageKey, event.container.data);
        });
      }
      return;
    }

    const ctx: MoveContext = {
      previousContainerData: event.previousContainer.data,
      currentContainerData: event.container.data,
      previousIndex: indiceOrigem,
    };

    // Nas etapas com NF entra no topo, o mesmo lugar em que o `confirmar` realoca.
    const indiceDestino = this.isEtapaAgrupadaPorNf(toStageKey) ? 0 : event.currentIndex;
    transferArrayItem(event.previousContainer.data, event.container.data, indiceOrigem, indiceDestino);
    card.stage = toStageKey;
    this.draggedCard = null;

    this.movimentarCard(card, fromStageKey, toStageKey, {
      rollback: () => this.rollbackMove(card, fromStageKey, toStageKey,
        ctx.previousContainerData, ctx.currentContainerData, ctx.previousIndex),
      confirmar: (confirmedStage) => {
        card.stage = confirmedStage;
        card.updatedAt = Date.now();
        if (confirmedStage !== toStageKey) {
          // Backend avançou o card para uma etapa diferente do destino do drop — realoca a coluna.
          const posicaoAtual = ctx.currentContainerData.indexOf(card);
          if (posicaoAtual >= 0) ctx.currentContainerData.splice(posicaoAtual, 1);
          if (!this.cardsByStage[confirmedStage]) this.cardsByStage[confirmedStage] = [];
          this.cardsByStage[confirmedStage] = [card, ...this.cardsByStage[confirmedStage]];
          this.cardsByStage = { ...this.cardsByStage };
        }
        // Card vindo de etapa sem NF (ex.: Pedido → Faturado) ainda não está no mapa das notas.
        if (this.isEtapaAgrupadaPorNf(confirmedStage)) this.carregarNotasDasEtapas();
      },
    });
  }

  /**
   * Pedidos da NF que se movem juntos: a moldura da coluna de origem. Para Finalizado (D-03 c) entram
   * também os das outras colunas com NF — a nota pode ter um pedido em Conferência e outro em Divergência.
   */
  private cardsDaNotaParaMover(idNFeEntrada: number, fromStageKey: string, toStageKey: string): KanbanCard[] {
    const etapas = toStageKey === 'finalizado'
      ? [...ETAPAS_AGRUPADAS_POR_NF].filter(chave => chave !== toStageKey)
      : [fromStageKey];
    return etapas.flatMap(chave => (this.cardsByStage[chave] ?? [])
      .filter(c => !!c.idCompra && this.notasPorCompra.get(c.idCompra)?.idNFeEntrada === idNFeEntrada));
  }

  /** Confirma mover junto os outros pedidos da NF (com a etapa de cada um, quando difere). */
  private confirmarMoverGrupoDaNota(cardsDaNota: KanbanCard[], idCompra: number): Observable<boolean> {
    const etapa = cardsDaNota.find(c => c.idCompra === idCompra)?.stage;
    const codigos = cardsDaNota
      .filter(c => c.idCompra !== idCompra)
      .map(c => c.stage === etapa ? c.id : `${c.id} (${this.getStage(c.stage)?.name || c.stage})`)
      .join(', ');
    return this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Mover pedidos da NF-e',
        description: `Os pedidos de uma NF-e entram em Finalizado juntos. Mover também ${codigos}?`,
        buttonConfirm: 'Mover todos',
        buttonClose: 'Voltar',
      },
    }).afterClosed().pipe(map(result => !!result?.confirm));
  }

  /**
   * Move os pedidos de uma mesma NF pelo PUT CompraEtapa/lote. Otimista como o card único (topo do
   * destino); qualquer recusa desfaz todos, e a justificativa segue o mesmo backstop do individual.
   * Cada card sai da própria coluna: para Finalizado o grupo pode vir de colunas diferentes e o
   * movimento roda no fluxo de finalização (NF confirmada, lançamento). `avisoMovido` é o toast de
   * sucesso do movimento. Resolve `true` quando moveu (para Finalizado, depois do lançamento).
   */
  private async moverGrupoDaNota(
    cards: KanbanCard[],
    fromStageKey: string,
    toStageKey: string,
    destino: KanbanCard[],
    avisoMovido?: string,
  ): Promise<boolean> {
    // Posições no array da origem em ordem crescente: reinserir nessa ordem devolve cada card ao seu lugar.
    const posicoes = cards
      .map(card => {
        const origem = this.cardsByStage[card.stage] ?? [];
        return { card, etapa: card.stage, origem, indice: origem.indexOf(card) };
      })
      .sort((a, b) => a.indice - b.indice);
    for (const { card, origem } of posicoes) {
      origem.splice(origem.indexOf(card), 1);
      card.stage = toStageKey;
    }
    destino.splice(0, 0, ...posicoes.map(p => p.card));
    const etapasOrigem = [...new Set(posicoes.map(p => p.etapa))];

    const rollback = () => {
      for (const { card, etapa } of posicoes) {
        const posicaoAtual = destino.indexOf(card);
        if (posicaoAtual >= 0) destino.splice(posicaoAtual, 1);
        card.stage = etapa;
      }
      for (const { card, origem, indice } of posicoes) {
        origem.splice(Math.min(indice, origem.length), 0, card);
      }
      this.cardsByStage = { ...this.cardsByStage };
      this.reconciliarMutacao([...etapasOrigem, toStageKey]);
    };

    const idsCompra = posicoes.map(p => p.card.idCompra!);
    // Moveu = resolve os lançamentos da response (preenchidos só na entrada em Finalizado); recusa, erro e
    // justificativa cancelada resolvem `null` já avisados e o rollback fica no fim, num lugar só.
    const mover = () => new Promise<CompraLancamentoFinalizacaoStruct[] | null>(resolve => {
      const executar = (justificativa: string | null) => {
        // Entrar em Finalizado notifica "Ao finalizar a compra": expande os perfis antes (perfil -> usuários
        // vive na API de Usuário). Nas outras etapas o lote não tem gatilho.
        const idsPerfil$: Observable<number[] | null> = toStageKey === 'finalizado'
          ? this.automacaoService.idsUsuarioDosPerfis(TipoOcorrenciaCompraEnum.Finalizacao)
          : of(null);
        idsPerfil$.pipe(
          switchMap(idsUsuarioPerfil => this.compraEtapaService.movimentarEtapaLote({
            idsCompra,
            chaveEtapaDestino: toStageKey,
            justificativa,
            idsUsuarioPerfil,
          })),
        ).subscribe({
          next: (res) => {
            if (res.isError) {
              // Todos passariam, mas a movimentação exige justificativa → pede e repete o lote.
              if (res.isExigeJustificativa && !justificativa) {
                this.pedirJustificativa(fromStageKey, toStageKey, { rollback: () => resolve(null), confirmar: () => {} }, executar);
                return;
              }
              if (res.isErroInterno) {
                this.alertService.show('Erro', res.errorDescription || 'Não foi possível mover os pedidos da NF.', AlertType.error);
              } else {
                this.alertService.show('Atenção', res.errorDescription || 'Não foi possível mover os pedidos da NF.', AlertType.warning);
              }
              resolve(null);
              return;
            }

            const etapasAfetadas = new Set<string>([...etapasOrigem, toStageKey]);
            for (const confirmada of res.compras ?? []) {
              const card = posicoes.find(p => p.card.idCompra === confirmada.idCompra)?.card;
              if (!card) continue;
              const confirmedStage = confirmada.chaveEtapa || toStageKey;
              card.stage = confirmedStage;
              card.updatedAt = Date.now();
              if (confirmedStage !== toStageKey) {
                // Backend deixou a compra numa etapa diferente do destino do drop — realoca a coluna.
                const posicaoAtual = destino.indexOf(card);
                if (posicaoAtual >= 0) destino.splice(posicaoAtual, 1);
                this.cardsByStage[confirmedStage] = [card, ...(this.cardsByStage[confirmedStage] ?? [])];
                etapasAfetadas.add(confirmedStage);
              }
            }
            this.cardsByStage = { ...this.cardsByStage };
            this.reconciliarMutacao([...etapasAfetadas]);
            this.carregarNotasDasEtapas();
            if (avisoMovido) this.alertService.show('Sucesso', avisoMovido, AlertType.success);
            resolve(res.lancamentos ?? []);
          },
          error: () => {
            this.alertService.show('Erro', 'Não foi possível mover os pedidos da NF.', AlertType.error);
            resolve(null);
          },
        });
      };
      executar(null);
    });

    const isMovido = toStageKey === 'finalizado'
      ? await this.finalizarPedidos(posicoes.map(p => p.card), mover)
      : (await mover()) !== null;
    if (!isMovido) rollback();
    return isMovido;
  }

  /**
   * Fluxo de finalização (D-11) com o lado do quadro: spinner nos cards enquanto as NFs são lançadas (o
   * quadro segue livre) e recarga do Finalizado no fim, para a pílula refletir as marcas por efeito (D-14).
   */
  private async finalizarPedidos(
    cards: KanbanCard[],
    mover: () => Promise<CompraLancamentoFinalizacaoStruct[] | null>,
  ): Promise<boolean> {
    // Antes de qualquer chamada: com a etapa Conferência ativa, pedido com NF só finaliza com volumes e itens
    // conferidos (mesma regra do PUT). Checar aqui evita abrir a Central por NF não confirmada quando o
    // impedimento real é a conferência. Pedido sem NF ou marcado "sem nota fiscal" não tem conferência.
    if (this.allStages.some(s => s.key === 'conferencia')) {
      const pendente = cards.find(card => !card.isSemNotaFiscal && this.notasPorCompra.has(card.idCompra!)
        && (card.idStatusConferenciaVolumes !== StatusConferenciaEnum.Concluida
          || card.idStatusConferenciaItens !== StatusConferenciaEnum.Concluida));
      if (pendente) {
        this.alertService.show('Atenção',
          `Pedido ${pendente.id}: conclua a conferência de volumes e de itens da NF-e antes de finalizar a compra.`,
          AlertType.warning);
        return false;
      }
    }
    const idsCompra = cards.map(card => card.idCompra!);
    // Mesma chave de `getCardOpenKey`: o spinner é o do card abrindo.
    const chaves = idsCompra.map(id => `compra:${id}`);
    // Rótulo do pedido nos toasts do lançamento pelo pedido.
    const rotulosCompra = new Map(cards.map(card => [card.idCompra!, `Pedido ${card.id}`]));
    let isMovido = false;
    const isFinalizado = await this.finalizacaoFluxo.finalizar(idsCompra, async () => {
      const lancamentos = await mover();
      isMovido = lancamentos !== null;
      if (isMovido) chaves.forEach(chave => this.loadingCardKeys.add(chave));
      return lancamentos;
    }, rotulosCompra);
    if (isMovido) {
      chaves.forEach(chave => this.loadingCardKeys.delete(chave));
      this.reconciliarMutacao(['finalizado']);
    }
    return isFinalizado;
  }

  private movimentarCard(
    card: KanbanCard,
    fromStageKey: string,
    toStageKey: string,
    strategy: MoveStrategy,
  ): void {
    if (!card.idCompra) return;

    // Para Finalizado o PUT roda dentro do fluxo de finalização, que troca a estratégia (abaixo) e recebe os
    // lançamentos da response.
    let estrategia = strategy;
    let lancamentos: CompraLancamentoFinalizacaoStruct[] = [];
    const executar = (justificativa: string | null) => {
      // Cancelar e finalizar notificam ("Ao cancelar" / "Ao finalizar a compra"): expande os perfis
      // antes (perfil -> usuários vive na API de Usuário). Nas outras etapas não há gatilho aqui,
      // então nem consulta.
      const gatilhoNotificacao = toStageKey === 'cancelado' ? TipoOcorrenciaCompraEnum.Cancelamento
        : toStageKey === 'finalizado' ? TipoOcorrenciaCompraEnum.Finalizacao
          : null;
      const idsPerfil$ = gatilhoNotificacao
        ? this.automacaoService.idsUsuarioDosPerfis(gatilhoNotificacao)
        : of([] as number[]);

      // Entrar em aprovação avisa os liberadores da faixa de valor: o backend decide a faixa, mas
      // depende dos vínculos perfil -> usuário, que só a API de Usuário sabe.
      const vinculos$ = toStageKey === 'aprovacao'
        ? this.etapasKanbanService.vinculosPerfilAprovadores()
        : of([] as PerfilUsuarioVinculoRequest[]);

      // Cancelar passa pelo Orquestrador: com o toggle da etapa Cancelado, a NF vinculada volta para a gaveta.
      const isCancelamento = toStageKey === 'cancelado';
      forkJoin({ idsUsuarioPerfil: idsPerfil$, vinculosPerfilUsuario: vinculos$ }).pipe(
        switchMap(({ idsUsuarioPerfil, vinculosPerfilUsuario }) => {
          const request: MovimentarCompraEtapaRequest = { chaveEtapaDestino: toStageKey, justificativa, idsUsuarioPerfil, vinculosPerfilUsuario };
          return isCancelamento
            ? this.orquestradorCompraEtapaService.movimentarEtapa(card.idCompra!, request)
            : this.compraEtapaService.movimentarEtapa(card.idCompra!, request);
        }),
      ).subscribe({
        next: (res) => {
          // Erro com a etapa Cancelado preenchida = cancelou e só a marca da NF falhou: aviso e recarga do quadro.
          if (res.isError && isCancelamento && res.chaveEtapa === 'cancelado' && !res.isExigeJustificativa) {
            this.alertService.show('Atenção', res.errorDescription, AlertType.warning);
            if (res.avisoDescricao) this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);
            estrategia.confirmar(res.chaveEtapa);
            this.recarregarKanban();
            this.invalidarLista();
            this.gaveta?.recarregar();
            return;
          }
          if (res.isError) {
            // A movimentação exige justificativa e o resto passaria (é a última regra do Validar) → pede e repete.
            if (res.isExigeJustificativa && !justificativa) {
              this.pedirJustificativa(fromStageKey, toStageKey, estrategia, executar);
              return;
            }
            // Backstop: avanço para Pedido com item avulso → vincula no modal (que já grava) e tenta de novo.
            if (res.isExigeAssociacaoProduto && res.itensAvulsos?.length) {
              const data: AssociarProdutosAvulsosDialogData = { idCompra: card.idCompra!, itensAvulsos: res.itensAvulsos };
              this.dialog.open(AssociarProdutosAvulsosDialogComponent, {
                data, autoFocus: false, maxWidth: '95vw', width: '760px', disableClose: true,
              }).afterClosed().subscribe((result?: AssociarProdutosAvulsosDialogResult) => {
                if (result?.confirmado) executar(justificativa);
                else estrategia.rollback();
              });
              return;
            }
            // Backstop: entrada em Faturado sem NF → escolhe e vincula a nota no modal. O vínculo já
            // move a compra (Faturado, ou Divergência com "Marcar divergência"): não se refaz a
            // movimentação — Divergência → Faturado não existe; o quadro e a gaveta recarregam.
            if (res.isExigeNotaFiscal) {
              const data: VincularNotaPedidoDialogData = {
                idCompra: card.idCompra!,
                codigoPedido: card.id,
                tituloPedido: card.title || null,
                nomeEtapaOrigem: this.getStage(fromStageKey)?.name || fromStageKey,
              };
              this.dialog.open(VincularNotaPedidoDialogComponent, {
                data, width: '96vw', height: '92vh', maxWidth: '100vw', maxHeight: '100vh', disableClose: true, autoFocus: false,
              }).afterClosed().subscribe((result?: VincularNotaPedidoDialogResult) => {
                if (!result?.vinculado) { estrategia.rollback(); return; }
                estrategia.confirmar(toStageKey);
                this.recarregarKanban();
                this.invalidarLista();
                this.gaveta?.recarregar();
              });
              return;
            }
            estrategia.rollback();
            if (res.isErroInterno) {
              this.alertService.show('Erro', res.errorDescription || 'Não foi possível mover o card.', AlertType.error);
            } else {
              this.alertService.show('Atenção', res.errorDescription || 'Não foi possível mover o card.', AlertType.warning);
            }
            return;
          }
          if (res.isGerouPedidos) {
            this.tratarPedidosGerados(res);
            return;
          }
          const confirmedStage = res.chaveEtapa || toStageKey;
          lancamentos = res.lancamentos ?? [];
          estrategia.confirmar(confirmedStage);
          this.reconciliarMutacao([fromStageKey, toStageKey, confirmedStage]);
          // Entrar em Faturado só acontece com NF vinculada — que sai da gaveta. A gaveta fica montada
          // mesmo fechada e alimenta o contador do botão; vale para o modal do quadro e o do card.
          if (confirmedStage === 'faturado') this.gaveta?.recarregar();
          const qtdNotasLiberadas = res.idsNotasDesvinculadas?.length ?? 0;
          if (qtdNotasLiberadas > 0) {
            this.alertService.show('Sucesso', qtdNotasLiberadas > 1
              ? `${qtdNotasLiberadas} NF-es liberadas para a gaveta de NFs.`
              : 'NF-e liberada para a gaveta de NFs.', AlertType.success);
            this.recarregarNotasLiberadas([card.idCompra!]);
          }
          // Cancelou, mas o desvínculo não entrou no histórico de alguma nota (só pelo Orquestrador).
          if (res.avisoDescricao) this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);
        },
        error: () => {
          estrategia.rollback();
          this.alertService.show('Erro', 'Não foi possível mover o card.', AlertType.error);
        },
      });
    };

    // Sem prompt antecipado: o PUT valida as regras e só devolve isExigeJustificativa quando o
    // movimento passaria; aí o backstop acima pede a justificativa e repete.
    if (toStageKey !== 'finalizado') {
      executar(null);
      return;
    }
    // Finalizado: o fluxo valida a NF, chama o PUT e lança. Dentro dele o rollback só resolve `null`
    // e é feito uma vez aqui (também quando a NF não está confirmada e o PUT nem roda).
    this.finalizarPedidos([card], () => new Promise<CompraLancamentoFinalizacaoStruct[] | null>(resolve => {
      estrategia = {
        rollback: () => resolve(null),
        confirmar: (confirmedStage) => {
          strategy.confirmar(confirmedStage);
          resolve(lancamentos);
        },
      };
      executar(null);
    })).then(isMovido => {
      if (!isMovido) strategy.rollback();
    });
  }

  /** Prompt de justificativa: segue com `executar` se preenchida, desfaz o movimento se cancelada. */
  private pedirJustificativa(
    fromStageKey: string,
    toStageKey: string,
    strategy: MoveStrategy,
    executar: (justificativa: string) => void,
  ): void {
    const ref = this.dialog.open(MovimentacaoJustificativaDialogComponent, {
      data: {
        origemNome: this.getStage(fromStageKey)?.name || fromStageKey,
        destinoNome: this.getStage(toStageKey)?.name || toStageKey,
      },
      autoFocus: false,
      width: '480px',
      maxWidth: '92vw',
    });
    ref.afterClosed().subscribe((justificativa: string | null) => {
      if (!justificativa) {
        // Cancelou — desfaz o movimento otimista.
        strategy.rollback();
        return;
      }
      executar(justificativa);
    });
  }

  /**
   * Cancelamento liberou NF(s) (toggle da etapa Cancelado): os pedidos saem do mapa das molduras e a
   * gaveta, que fica montada mesmo fechada e alimenta o contador do botão, recarrega.
   */
  private recarregarNotasLiberadas(idsCompra: number[]): void {
    idsCompra.forEach(id => this.notasPorCompra.delete(id));
    this.carregarNotasDasEtapas();
    this.gaveta?.recarregar();
  }

  private reconciliarMutacao(chaves: (string | null | undefined)[]): void {
    this.resetarEtapas(chaves);
    this.invalidarLista();
  }

  /**
   * Cotação com mais de um fornecedor vencedor ao avançar para Pedido: o card não se moveu —
   * nasceram pedidos direto em Pedido e a cotação foi arquivada. Recarrega o quadro inteiro
   * (a cotação saiu + N cards novos).
   */
  private tratarPedidosGerados(res: MovimentarCompraEtapaResponse): void {
    const codigos = (res.pedidosGerados ?? []).map(p => formatCodigoCompra(p.codigo)).join(', ');
    this.alertService.show('Pedidos gerados',
      `Cotação convertida em ${res.pedidosGerados?.length ?? 0} pedidos: ${codigos}.`, AlertType.success);
    this.carregarCards();
    this.invalidarLista();
  }

  private moverCardViaDialogo(card: KanbanCard, fromStageKey: string, toStageKey: string): void {
    if (!card.idCompra) return;

    // Os pedidos de uma NF entram em Finalizado juntos (D-03(c)): com outros pedidos da mesma NF no
    // quadro, propõe mover o grupo. As referências são as das colunas (o card do modal é cópia);
    // cancelar não move nada.
    const nota = this.notasPorCompra.get(card.idCompra);
    const cardsDaNota = toStageKey === 'finalizado' && nota && this.isEtapaAgrupadaPorNf(fromStageKey)
      ? this.cardsDaNotaParaMover(nota.idNFeEntrada, fromStageKey, toStageKey)
      : [];
    if (cardsDaNota.length > 1 && cardsDaNota.some(c => c.idCompra === card.idCompra)) {
      this.confirmarMoverGrupoDaNota(cardsDaNota, card.idCompra).subscribe(isConfirmado => {
        if (!isConfirmado) {
          // O modal do card pode ter gravado algo antes do avanço: a coluna recarrega do backend.
          this.reconciliarMutacao([fromStageKey]);
          return;
        }
        // As colunas podem ter recarregado enquanto o modal estava aberto: o grupo sai dos arrays atuais.
        const grupo = this.cardsDaNotaParaMover(nota!.idNFeEntrada, fromStageKey, toStageKey)
          .filter(c => cardsDaNota.some(d => d.idCompra === c.idCompra));
        if (!grupo.length) {
          this.reconciliarMutacao([fromStageKey]);
          return;
        }
        this.suppressProgrammaticCardAnimation();
        if (!this.cardsByStage[toStageKey]) this.cardsByStage[toStageKey] = [];
        this.moverGrupoDaNota(grupo, fromStageKey, toStageKey, this.cardsByStage[toStageKey]);
      });
      return;
    }

    this.suppressProgrammaticCardAnimation();

    const now = Date.now();
    this.allStages.forEach(s => {
      this.cardsByStage[s.key] = (this.cardsByStage[s.key] || []).filter(c => c.id !== card.id);
    });
    if (!this.cardsByStage[toStageKey]) this.cardsByStage[toStageKey] = [];
    const cardMoved: KanbanCard = { ...card, stage: toStageKey, updatedAt: now, renderKey: `${card.id}-${toStageKey}-${now}` };
    this.cardsByStage[toStageKey] = [cardMoved, ...this.cardsByStage[toStageKey]];

    this.movimentarCard(card, fromStageKey, toStageKey, {
      rollback: () => {
        this.cardsByStage[toStageKey] = (this.cardsByStage[toStageKey] || []).filter(c => c.id !== card.id);
        if (!this.cardsByStage[fromStageKey]) this.cardsByStage[fromStageKey] = [];
        this.cardsByStage[fromStageKey] = [{ ...cardMoved, stage: fromStageKey }, ...this.cardsByStage[fromStageKey]];
        card.stage = fromStageKey;
        this.cardsByStage = { ...this.cardsByStage };
        this.reconciliarMutacao([fromStageKey, toStageKey]);
      },
      confirmar: (confirmedStage) => {
        if (confirmedStage === toStageKey) return;
        this.cardsByStage[toStageKey] = (this.cardsByStage[toStageKey] || []).filter(c => c.id !== card.id);
        if (!this.cardsByStage[confirmedStage]) this.cardsByStage[confirmedStage] = [];
        this.cardsByStage[confirmedStage] = [{ ...cardMoved, stage: confirmedStage }, ...this.cardsByStage[confirmedStage]];
      },
    });
  }

  /**
   * "Mover automaticamente" ao concluir a conferência (D-13): o card fechou com a NF cuja conferência concluiu.
   * Todos os pedidos da NF vão para Finalizado pelo fluxo de finalização, sem a confirmação do grupo (é a
   * automação). Recusa do backend vira o toast de sempre e nada se move.
   */
  private finalizarAutomatico(idNFeEntrada: number, fromStageKey: string): void {
    const cards = this.cardsDaNotaParaMover(idNFeEntrada, fromStageKey, 'finalizado');
    if (!cards.length) {
      // Pedidos da NF fora do quadro (filtro ou paginação): a coluna recarrega e o movimento fica manual.
      this.reconciliarMutacao([fromStageKey]);
      this.alertService.show('Atenção',
        'Conferência concluída, mas os pedidos da NF-e não estão no quadro para mover para Finalizado.', AlertType.warning);
      return;
    }
    const nota = this.notasPorCompra.get(cards[0].idCompra!);
    const rotulo = nota ? rotuloNotaFiscal(nota.numero, nota.serie) : 'NF-e';
    // A conferência acabou de ser concluída no card: os cards do quadro ainda têm a situação antiga.
    cards.forEach(card => {
      card.idStatusConferenciaVolumes = StatusConferenciaEnum.Concluida;
      card.idStatusConferenciaItens = StatusConferenciaEnum.Concluida;
    });
    this.suppressProgrammaticCardAnimation();
    if (!this.cardsByStage['finalizado']) this.cardsByStage['finalizado'] = [];
    this.moverGrupoDaNota(cards, fromStageKey, 'finalizado', this.cardsByStage['finalizado'],
      `Conferência concluída: pedidos da ${rotulo} movidos para Finalizado.`);
  }

  private rollbackMove(
    card: KanbanCard,
    fromStageKey: string,
    toStageKey: string,
    previousContainerData: KanbanCard[],
    currentContainerData: KanbanCard[],
    previousIndex: number,
  ): void {
    // Localiza o card pela referência: o índice do drop não serve (ordem renderizada ≠ array nas etapas com NF).
    const currentPos = currentContainerData.indexOf(card);
    if (currentPos >= 0) currentContainerData.splice(currentPos, 1);
    previousContainerData.splice(Math.min(previousIndex, previousContainerData.length), 0, card);
    card.stage = fromStageKey;
    this.cardsByStage = { ...this.cardsByStage };
    this.reconciliarMutacao([fromStageKey, toStageKey]);
  }

  /**
   * Início do arraste. Nas etapas com NF o cdkDrag é a moldura inteira (a NF vai junto no preview) e o
   * dado é o primeiro pedido; o pedido que o drop usa é o que estava sob o ponteiro — agarrando o
   * cabeçalho, o primeiro. Assim Cancelar continua individual mesmo com a moldura arrastada.
   */
  dragStarted(card: KanbanCard, event: CdkDragStart, grupo?: GrupoCardsEtapa): void {
    const elemento = event.source.element.nativeElement;
    let agarrado = card;
    if (grupo) {
      const alvo = event.event.target instanceof Element ? event.event.target.closest('.pc-card') : null;
      const indice = alvo ? Array.from(elemento.querySelectorAll(':scope > .pc-nf-grupo-cards > .pc-card')).indexOf(alvo) : -1;
      if (indice >= 0 && grupo.cards[indice]) agarrado = grupo.cards[indice];
    }
    this.cardAgarrado = agarrado;
    this.draggedCard = agarrado;
    this.alturaCardArrastado = elemento.offsetHeight;
  }

  dragEnded(): void {
    this.draggedCard = null;
    this.etapaSlotTopo = null;
  }

  entrouNaEtapa(stageKey: string): void {
    const card = this.draggedCard;
    this.etapaSlotTopo = !!card && this.isEtapaAgrupadaPorNf(stageKey) && card.stage !== stageKey && !this.isDropBlocked(stageKey)
      ? stageKey
      : null;
  }

  toggleCollapse(stageKey: string): void {
    if (this.collapsedStages.has(stageKey)) {
      this.collapsedStages.delete(stageKey);
    } else {
      this.collapsedStages.add(stageKey);
    }
  }

  toggleCollapsedStage(stage: KanbanStage): void {
    if (stage.podeVisualizar === false) {
      return;
    }

    this.toggleCollapse(stage.key);
  }

  getCollapsedStageTooltip(stage: KanbanStage): string {
    if (stage.podeVisualizar === false) {
      return `Você não tem permissão para visualizar a etapa ${stage.name}.`;
    }

    return `Expandir ${stage.name}`;
  }

  isCollapsed(stageKey: string): boolean {
    return this.collapsedStages.has(stageKey);
  }

  isDropBlocked(stageKey: string): boolean {
    if (!this.draggedCard) return false;
    return !this.canDrop(this.draggedCard, stageKey);
  }

  getColumnTotal(stageKey: string): string {
    return fmtMoneyDisplay(this.etapaEstado(stageKey).somaValor);
  }

  cardValueLabel(value: string): string {
    return value === '—' ? '—' : `R$ ${value}`;
  }

  /** Status calculado pelas etapas fixas (exceção da compra); o filtro é resolvido na API Compras. */
  readonly statusFiltroOpcoes: { value: string; label: string }[] = [
    { value: 'em_andamento', label: 'Em andamento' },
    { value: 'concluido', label: 'Concluído' },
    { value: 'cancelado', label: 'Cancelado' },
  ];

  get hasActiveFilters(): boolean {
    const { searchText, filterRespId, filterPrio, filterStatus } = this.appliedFilters;
    return !!(searchText || filterRespId || filterPrio || filterStatus);
  }

  get qtdFiltrosAvancados(): number {
    const { filterRespId, filterPrio, filterStage, filterStatus } = this.appliedFilters;
    const contaEtapa = this.activeTab === 'lista' && !!filterStage ? 1 : 0;
    return (filterRespId != null ? 1 : 0) + (filterPrio ? 1 : 0) + contaEtapa + (filterStatus ? 1 : 0);
  }

  colunaCards(stageKey: string): KanbanCard[] {
    return this.cardsByStage[stageKey] || [];
  }

  /**
   * Cards da coluna agrupados pela NF vinculada. Só nas etapas com NF: cada nota vira
   * uma moldura, mesmo com um pedido só; card sem nota no mapa e demais etapas ficam soltos. Os grupos
   * seguem a posição do primeiro card na lista; dentro do grupo, a ordem da lista.
   */
  gruposDaEtapa(stageKey: string): GrupoCardsEtapa[] {
    const cards = this.colunaCards(stageKey);
    const agrupar = this.isEtapaAgrupadaPorNf(stageKey);
    const grupos: GrupoCardsEtapa[] = [];
    const porNota = new Map<number, GrupoCardsEtapa>();

    for (const card of cards) {
      const nota = agrupar && card.idCompra ? this.notasPorCompra.get(card.idCompra) : undefined;
      if (!nota) {
        grupos.push({
          chave: `card:${card.renderKey || card.id}`, idNFeEntrada: null, isGrupo: false,
          rotulo: '', pedidosLabel: '', totalLabel: '', cards: [card],
        });
        continue;
      }

      let grupo = porNota.get(nota.idNFeEntrada);
      if (!grupo) {
        grupo = {
          chave: `nf:${nota.idNFeEntrada}`, idNFeEntrada: nota.idNFeEntrada, isGrupo: true,
          rotulo: rotuloNotaFiscal(nota.numero, nota.serie), pedidosLabel: '', totalLabel: '', cards: [],
        };
        porNota.set(nota.idNFeEntrada, grupo);
        grupos.push(grupo);
      }
      grupo.cards.push(card);
    }

    porNota.forEach(grupo => {
      const qtd = grupo.cards.length;
      // Soma só dos cards carregados do grupo (a paginação pode deixar pedidos da nota fora da coluna).
      const total = grupo.cards.reduce((soma, card) => soma + parseBR(card.value), 0);
      grupo.pedidosLabel = `${qtd} ${qtd > 1 ? 'pedidos' : 'pedido'}`;
      grupo.totalLabel = this.cardValueLabel(fmtMoneyDisplay(total));
    });

    return grupos;
  }

  getPerson(key: string, name?: string, color?: string): Person {
    return {
      idUsuario: 0,
      name: name || key || 'Sem responsável',
      color: color || '#888',
      initials: key || '?',
    };
  }

  /** Título do card no quadro: tipo do documento pela etapa + número. O nome do produto fica no detalhe. */
  getCardTitle(card: KanbanCard): string {
    const tipo = TITULO_POR_ETAPA[card.stage] || 'Pedido';
    return card.id ? `${tipo} ${card.id}` : tipo;
  }

  /** Progresso da conferência física no card do board: só na etapa Conferência. */
  temProgressoConferencia(card: KanbanCard): boolean {
    return card.stage === 'conferencia';
  }

  /** Classe de cada segmento da barra (volumes, itens): concluído, em andamento ou não iniciado (sem modificador). */
  passosConferencia(card: KanbanCard): string[] {
    return [card.idStatusConferenciaVolumes, card.idStatusConferenciaItens].map(status =>
      status === StatusConferenciaEnum.Concluida ? 'pc-card-conf-passo--concluido'
        : status === StatusConferenciaEnum.EmAndamento ? 'pc-card-conf-passo--andamento'
          : '');
  }

  resumoConferencia(card: KanbanCard): string {
    const volumes = card.idStatusConferenciaVolumes;
    const itens = card.idStatusConferenciaItens;
    if (volumes === StatusConferenciaEnum.Concluida && itens === StatusConferenciaEnum.Concluida) {
      return (card.quantidadeDivergenciasConferencia ?? 0) > 0
        ? 'Concluídos com divergência'
        : 'Recebimento e conferência concluídos';
    }
    const resumoVolumes = volumes === StatusConferenciaEnum.Concluida ? 'Volumes recebidos'
      : volumes === StatusConferenciaEnum.EmAndamento ? 'Recebimento em andamento'
        : 'Volumes pendentes';
    const resumoItens = itens === StatusConferenciaEnum.Concluida ? 'Itens conferidos'
      : itens === StatusConferenciaEnum.EmAndamento ? 'Conferência em andamento'
        : 'Itens pendentes';
    return `${resumoVolumes} · ${resumoItens}`;
  }

  isConferenciaCega(card: KanbanCard): boolean {
    return !!this.getStage(card.stage).isConferenciaCega;
  }

  getPrioColor(prio: string): string {
    return PRIO_CONFIG[prio]?.color || '#888';
  }

  /** Status calculado pelas etapas fixas: Finalizado = Concluído, Cancelado = Cancelado, demais = Em andamento. */
  getStatusFor(c: KanbanCard): { bg: string; fg: string; label: string } {
    if (c.stage === 'finalizado') return { bg: '#E6F4EA', fg: '#1E8E3E', label: 'Concluído' };
    if (c.stage === 'cancelado')  return { bg: '#F3F4F6', fg: '#4B5563', label: 'Cancelado' };
    return { bg: '#FDFDEC', fg: '#786704', label: 'Em andamento' };
  }

  /** Indicadores do card, na ordem fixa (E, F), só quando a própria compra lançou o efeito. */
  integracoes(card: KanbanCard): { sigla: string; rotulo: string; cor: string }[] {
    const indicadores: { sigla: string; rotulo: string; cor: string }[] = [];
    if (card.isEstoqueLancado) {
      const estoque = TipoIntegracaoIndicador[TipoIntegracaoEnum.Estoque];
      indicadores.push({ sigla: estoque.sigla, rotulo: 'Estoque lançado', cor: estoque.cor });
    }
    if (card.isFinanceiroLancado) {
      const financeiro = TipoIntegracaoIndicador[TipoIntegracaoEnum.Financeiro];
      indicadores.push({ sigla: financeiro.sigla, rotulo: 'Financeiro lançado', cor: financeiro.cor });
    }
    return indicadores;
  }

  get totalCardsVisiveis(): number {
    if (this.activeTab === 'lista') return this.listaTotalRegistros;
    return this.allStages.reduce((soma, s) => soma + this.totalDaEtapa(s.key), 0);
  }

  selecionarAba(tab: 'kanban' | 'lista'): void {
    this.activeTab = tab;
    this.posicionarIndicadorAbas();
    if (tab === 'lista' && this.listaDesatualizada) this.recarregarLista();
    setTimeout(() => this.atualizarScrollDoConteudo());
  }

  @HostListener('window:resize')
  posicionarIndicadorAbas(): void {
    const botao = (this.activeTab === 'lista' ? this.tabBtnLista : this.tabBtnKanban)?.nativeElement;
    if (!botao) return;
    this.indicadorX = botao.offsetLeft;
    this.indicadorW = botao.offsetWidth;
    this.atualizarScrollDoConteudo();
  }

  @HostListener('window:scroll')
  atualizarScrollDoConteudo(): void {
    if (typeof window === 'undefined') return;

    // Só o Kanban rola em duas fases; a Lista rola com a página.
    const conteudo = this.activeTab === 'kanban' ? this.boardWrapper?.nativeElement : undefined;
    if (!conteudo) {
      this.conteudoViewportAtivo = false;
      return;
    }

    const bannerHeight = Number.parseFloat(getComputedStyle(document.body).getPropertyValue('--alert-banner-height')) || 0;
    const topOffset = Number.parseFloat(getComputedStyle(conteudo).getPropertyValue('--pc-conteudo-top-offset')) || 0;
    this.conteudoViewportAtivo = conteudo.getBoundingClientRect().top <= bannerHeight + topOffset + 1;
  }

  private invalidarLista(): void {
    this.listaDesatualizada = true;
    if (this.activeTab === 'lista') this.recarregarLista();
  }

  private recarregarLista(): void {
    this.buscarPaginaLista(0, true);
  }

  carregarMaisCards(): void {
    if (this.listaCarregando || this.listaUltimaPagina) return;
    this.buscarPaginaLista(this.listaPaginaAtual + 1, false);
  }

  private buscarPaginaLista(pagina: number, substituir: boolean): void {
    const token = ++this.listaToken;
    this.listaCarregando = true;
    this.listaDesatualizada = false;

    this.compraService.getLista(this.montarFiltros(), pagina, this.listPageSize).subscribe({
      next: (res) => {
        if (token !== this.listaToken) return;
        this.listaCarregando = false;
        if (res.isError) {
          this.listaUltimaPagina = true;
          this.alertService.show('Erro', res.errorDescription || 'Não foi possível carregar a lista de compras.', AlertType.error);
          return;
        }
        const cards = (res.lista ?? []).map(c => this.mapCard(c));
        this.carregarNomesFornecedores(cards);
        this.listaCards = substituir ? cards : [...this.listaCards, ...cards];
        this.listaPaginaAtual = res.pagina ?? pagina;
        this.listaTotalRegistros = res.totalRegistros;
        this.listaUltimaPagina = !res.temMais;
        if (substituir) this.listSelection.clear();
        this.reordenarLista();
      },
      error: () => {
        if (token !== this.listaToken) return;
        this.listaCarregando = false;
        this.listaUltimaPagina = true;
        this.alertService.show('Erro', 'Não foi possível carregar a lista de compras.', AlertType.error);
      },
    });
  }

  private reordenarLista(): void {
    const dir = this.listSortDirection === 'asc' ? 1 : this.listSortDirection === 'desc' ? -1 : 0;
    if (!this.listSortActive || dir === 0) {
      this.paginatedCards = [...this.listaCards].sort((a, b) => this.parseCardId(b.id) - this.parseCardId(a.id));
      return;
    }
    this.paginatedCards = [...this.listaCards].sort((a, b) => dir * this.compareListColumn(a, b, this.listSortActive));
  }

  /** Ordenação real da coluna clicada (mat-sort-header) — mesmo comportamento das outras listas do sistema. */
  onListSortChange(sort: Sort): void {
    this.listSortActive = sort.active;
    this.listSortDirection = sort.direction;
    this.reordenarLista();
  }

  private compareListColumn(a: KanbanCard, b: KanbanCard, column: string): number {
    switch (column) {
      case 'id': return this.parseCardId(a.id) - this.parseCardId(b.id);
      case 'title': return compararValoresOrdenacao(a.title, b.title);
      case 'stage': return compararValoresOrdenacao(this.getStage(a.stage).name, this.getStage(b.stage).name);
      case 'resp': return compararValoresOrdenacao(this.getPerson(a.resp, a.respName, a.respColor).name, this.getPerson(b.resp, b.respName, b.respColor).name);
      case 'prio': return this.prioWeight(a.prio) - this.prioWeight(b.prio);
      case 'date': return this.parseDataBR(a.date) - this.parseDataBR(b.date);
      case 'status': return compararValoresOrdenacao(this.getStatusFor(a).label, this.getStatusFor(b).label);
      default: return 0;
    }
  }

  private parseCardId(id: string): number {
    return parseInt(id.replace('#', ''), 10) || 0;
  }

  private prioWeight(prio: string): number {
    return { alta: 3, media: 2, baixa: 1 }[prio] ?? 0;
  }

  private parseDataBR(date: string): number {
    const [d, m, y] = (date || '').split('/').map(n => parseInt(n, 10));
    if (!d || !m || !y) return 0;
    return new Date(y, m - 1, d).getTime();
  }

  // ----- Seleção da Lista (mat-checkbox) — opera sobre a página atual, como o resto do sistema -----
  isListAllSelected(): boolean {
    return this.paginatedCards.length > 0 && this.listSelection.selected.length === this.paginatedCards.length;
  }

  toggleListAllRows(): void {
    this.isListAllSelected() ? this.listSelection.clear() : this.listSelection.select(...this.paginatedCards);
  }

  // ----- Ações em lote -----
  get temSelecionados(): boolean {
    return this.listSelection.hasValue();
  }

  cancelarSelecionadas(): void {
    const cards = this.listSelection.selected.filter(c => !!c.idCompra);
    if (!cards.length) return;

    const jaCanceladas = cards.filter(c => c.stage === 'cancelado').length;
    if (jaCanceladas === cards.length) {
      this.alertService.show('Atenção', 'As compras selecionadas já estão canceladas.', AlertType.warning);
      return;
    }

    const alvos = cards.filter(c => c.stage !== 'cancelado');
    const descricao = jaCanceladas > 0
      ? `Confirma o cancelamento de ${alvos.length} compra(s)? ${jaCanceladas} já cancelada(s) será(ão) ignorada(s). A justificativa é registrada no histórico de cada card.`
      : `Confirma o cancelamento de ${alvos.length} compra(s)? A justificativa é registrada no histórico de cada card.`;

    this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Cancelar compras',
        description: descricao,
        buttonConfirm: 'Cancelar compras',
        buttonClose: 'Voltar',
        showTextarea: true,
        textareaLabel: 'Justificativa',
        textareaRequired: true,
        textareaMinLength: 3,
      },
    }).afterClosed().subscribe((result) => {
      if (!result?.confirm) return;
      this.executarCancelamentoEmLote(alvos, (result.textareaValue as string).trim());
    });
  }

  /**
   * Etapa terminal (isFinal) não admite cancelamento: o card já encerrou o fluxo.
   * "cancelado" entra por fora porque é etapa especial, não final.
   */
  isCancelamentoBloqueado(card: KanbanCard): boolean {
    if (!this.podeCancelarCompra) return true;
    if (card.stage === 'cancelado') return true;
    return this.allStages.some(s => s.key === card.stage && s.isFinal);
  }

  /** Motivo do bloqueio — serve ao tooltip do item desabilitado e ao alerta de fallback. */
  motivoCancelamentoBloqueado(card: KanbanCard): string {
    if (!this.podeCancelarCompra) return this.semPermissaoCancelarCompra;
    return card.stage === 'cancelado'
      ? 'Esta compra já está cancelada.'
      : 'Esta compra está em uma etapa final do fluxo e não pode mais ser cancelada.';
  }

  /** Cancelamento pelo menu da linha — mesmo fluxo do lote, com um card só. */
  cancelarCard(card: KanbanCard): void {
    if (!card.idCompra) return;

    if (this.isCancelamentoBloqueado(card)) {
      this.alertService.show('Atenção', this.motivoCancelamentoBloqueado(card), AlertType.warning);
      return;
    }

    this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Cancelar compra',
        description: `Confirma o cancelamento da compra "${card.title}"? A justificativa é registrada no histórico do card.`,
        buttonConfirm: 'Cancelar compra',
        buttonClose: 'Voltar',
        showTextarea: true,
        textareaLabel: 'Justificativa',
        textareaRequired: true,
        textareaMinLength: 3,
      },
    }).afterClosed().subscribe((result) => {
      if (!result?.confirm) return;
      this.executarCancelamentoEmLote([card], (result.textareaValue as string).trim());
    });
  }

  private executarCancelamentoEmLote(cards: KanbanCard[], justificativa: string): void {
    this.acoesLoading = true;
    const ids = cards.map(c => c.idCompra!);

    // Expande os perfis notificados antes de cancelar: o backend não resolve perfil -> usuários.
    this.automacaoService.idsUsuarioDosPerfis(TipoOcorrenciaCompraEnum.Cancelamento).pipe(
      // Pelo Orquestrador: com o toggle da etapa Cancelado, as NFs vinculadas voltam para a gaveta.
      switchMap(idsUsuarioPerfil => this.orquestradorCompraEtapaService.bulkCancelar({ ids, justificativa, idsUsuarioPerfil })),
    ).subscribe({
      next: (res) => {
        this.acoesLoading = false;
        // Erro com cancelados = o lote foi cancelado e só a marca das NFs falhou: aviso e segue recarregando.
        const isCanceladoComAviso = res.isError && res.totalCancelados > 0;
        if (res.isError && !isCanceladoComAviso) {
          this.alertService.show(res.isErroInterno ? 'Erro' : 'Atenção',
            res.errorDescription || 'Não foi possível cancelar as compras.',
            res.isErroInterno ? AlertType.error : AlertType.warning);
          return;
        }

        if (res.totalCancelados > 0) {
          this.alertService.show('Sucesso', `${res.totalCancelados} compra(s) cancelada(s).`, AlertType.success);
        }
        if (res.totalIgnorados > 0) {
          this.alertService.show('Atenção', this.resumirIgnoradas(res.resultados ?? []), AlertType.warning);
        }
        const qtdNotasLiberadas = res.idsNotasDesvinculadas?.length ?? 0;
        if (isCanceladoComAviso) {
          this.alertService.show('Atenção', res.errorDescription, AlertType.warning);
        } else if (qtdNotasLiberadas > 0) {
          this.alertService.show('Sucesso', qtdNotasLiberadas > 1
            ? `${qtdNotasLiberadas} NF-es liberadas para a gaveta de NFs.`
            : 'NF-e liberada para a gaveta de NFs.', AlertType.success);
        }
        // Cancelou, mas o desvínculo não entrou no histórico de alguma nota.
        if (res.avisoDescricao) this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);
        if (isCanceladoComAviso || qtdNotasLiberadas > 0) this.recarregarNotasLiberadas(ids);

        this.listSelection.clear();
        this.carregarCards();
        this.invalidarLista();
      },
      error: () => {
        this.acoesLoading = false;
        this.alertService.show('Erro', 'Não foi possível cancelar as compras.', AlertType.error);
      },
    });
  }

  private resumirIgnoradas(resultados: BulkCancelarCompraItemResultStruct[]): string {
    const motivo: Record<StatusCancelamentoCompraEnum, string> = {
      [StatusCancelamentoCompraEnum.Cancelado]: '',
      [StatusCancelamentoCompraEnum.JaCancelado]: 'já canceladas',
      [StatusCancelamentoCompraEnum.NaoEncontrado]: 'não encontradas',
      [StatusCancelamentoCompraEnum.SemPermissaoNaEtapa]: 'sem permissão na etapa atual',
      [StatusCancelamentoCompraEnum.MovimentacaoNaoPermitida]: 'sem movimentação configurada para Cancelado',
      [StatusCancelamentoCompraEnum.LancamentoGerado]: 'com lançamento da NF-e já gerado',
    };

    const grupos = resultados
      .filter(r => r.status !== StatusCancelamentoCompraEnum.Cancelado)
      .reduce((acc, r) => {
        (acc[r.status] ??= []).push(r.codigo ? formatCodigoCompra(r.codigo) : formatCodigoCompra(r.idCompra));
        return acc;
      }, {} as Record<number, string[]>);

    return Object.entries(grupos)
      // Fallback: status novo no backend não pode virar "N undefined" na tela do usuário.
      .map(([status, codigos]) => `${codigos.length} ${motivo[Number(status) as StatusCancelamentoCompraEnum] || 'ignoradas'} (${codigos.slice(0, 3).join(', ')}${codigos.length > 3 ? '…' : ''})`)
      .join(' · ');
  }

  exportarSelecionadas(): void {
    this.baixarCsvCompras(this.listSelection.selected);
  }

  exportarLista(): void {
    // O menu "Ações" vive no header e também aparece na aba Kanban, mas `paginatedCards` só é
    // populado ao entrar na aba Lista — exportar dali dizia "não há compras" com o quadro cheio.
    const cards = this.activeTab === 'lista'
      ? this.paginatedCards
      : Object.values(this.cardsByStage).flat();

    if (!cards.length) {
      this.alertService.show('Atenção', 'Não há compras para exportar.', AlertType.warning);
      return;
    }
    this.baixarCsvCompras(cards);
  }

  private baixarCsvCompras(cards: KanbanCard[]): void {
    if (!cards.length) return;

    const cabecalho = ['#', 'Título', 'Fornecedor', 'Etapa atual', 'Responsável', 'Prioridade', 'Criado em', 'Status', 'Integrações', 'Valor (R$)'];
    const linhas = cards.map(card => [
      card.id,
      card.title || '',
      this.nomeFornecedor(card),
      this.getStage(card.stage).name,
      this.getPerson(card.resp, card.respName, card.respColor).name,
      this.prioConfig[card.prio]?.label || card.prio,
      card.date || '',
      this.getStatusFor(card).label,
      this.integracoes(card).map(integracao => integracao.sigla).join(' '),
      card.value === '—' ? '' : card.value,
    ]);

    const csv = [cabecalho, ...linhas]
      .map(linha => linha.map(valor => this.escaparCsv(valor)).join(';'))
      .join('\r\n');

    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const agora = new Date();
    const stamp = `${agora.getFullYear()}${String(agora.getMonth() + 1).padStart(2, '0')}${String(agora.getDate()).padStart(2, '0')}`
      + `-${String(agora.getHours()).padStart(2, '0')}${String(agora.getMinutes()).padStart(2, '0')}`;

    link.href = url;
    link.download = `compras-${stamp}.csv`;
    link.click();
    URL.revokeObjectURL(url);

    this.alertService.show('Sucesso', `${cards.length} compra(s) exportada(s).`, AlertType.success);
  }

  private escaparCsv(valor: string): string {
    const texto = (valor ?? '').toString();
    return /[";\r\n]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
  }

  isCardLoading(card: KanbanCard): boolean {
    return this.loadingCardKeys.has(this.getCardOpenKey(card));
  }

  /**
   * `nota` fixa a NF do modo NF (moldura da nota, troca de pedido/NF no card). Sem ela, o card do Faturado em
   * diante com NF vinculada abre no modo NF pela NF mais recente do pedido (resolvido no próprio card).
   */
  openCard(card: KanbanCard, detalhePreCarregado?: DetalheCompraResponse, nota?: CardNotaContexto): void {
    const openKey = this.getCardOpenKey(card);
    if (this.openingCardKeys.has(openKey)) return;

    this.openingCardKeys.add(openKey);
    const releaseOpenLock = () => this.openingCardKeys.delete(openKey);
    const releaseLoading = () => this.loadingCardKeys.delete(openKey);

    const abrir = (detalhe?: DetalheCompraResponse, nativosObrigatorios: number[] = []) => {
      releaseLoading();
      const fromStageKey = card.stage;
      const ref = this.dialog.open(CardEditDialogComponent, {
          data: {
            card, allStages: this.allStages, transitions: this.effectiveTransitions, detalhe, usersById: this.usersById,
            nativosObrigatorios, nota, podeCancelarCompra: this.podeCancelarCompra,
          },
          panelClass: 'card-edit-panel',
          maxWidth: '100vw',
          maxHeight: '100vh',
          disableClose: true,
          autoFocus: 'dialog',
        });
      ref.afterClosed().subscribe((result) => {
        releaseOpenLock();
        // Aprovação e cotação (preços, fornecedores, respostas) gravam na hora, sem passar pelo
        // "Salvar": o fechamento não traz o card alterado, então a coluna é recarregada do backend.
        if (!result) {
          this.reconciliarMutacao([fromStageKey]);
          return;
        }
        const { card: updated, action } = result;
        if (action === 'abrir-compra') {
          this.reconciliarMutacao([fromStageKey]);
          this.abrirCompraPorId(result.idCompra);
          return;
        }
        // Modo NF: troca de pedido da nota ou de NF do pedido — reabre o card com a nota escolhida no card.
        if (action === 'abrir-pedido-nota') {
          this.reconciliarMutacao([fromStageKey]);
          this.abrirCompraPorId(result.idCompra, result.nota);
          return;
        }
        if (action === 'advance' || action === 'back') {
          this.moverCardViaDialogo(updated, fromStageKey, updated.stage);
          return;
        }
        if (action === 'finalizar-automatico') {
          this.finalizarAutomatico(result.idNFeEntrada, fromStageKey);
          return;
        }
        const isStageMove = action === 'cancel';
        if (isStageMove) {
          this.suppressProgrammaticCardAnimation();
        }
        this.allStages.forEach(s => {
          this.cardsByStage[s.key] = (this.cardsByStage[s.key] || []).filter(c => c.id !== updated.id);
        });
        if (!this.cardsByStage[updated.stage]) this.cardsByStage[updated.stage] = [];
        if (action === 'saved' || isStageMove) {
          const now = Date.now();
          const cardToInsert: KanbanCard = {
            ...updated,
            updatedAt: now,
            renderKey: isStageMove ? `${updated.id}-${updated.stage}-${now}` : updated.renderKey,
          };
          this.cardsByStage[cardToInsert.stage] = [cardToInsert, ...this.cardsByStage[cardToInsert.stage]];
        } else {
          this.cardsByStage[updated.stage] = [...this.cardsByStage[updated.stage], updated];
        }
        this.reconciliarMutacao([fromStageKey, updated.stage]);
        // "Cancelar" do card liberou a NF (toggle da etapa Cancelado): o card já avisou; aqui só recarrega.
        if (action === 'cancel' && result.idsNotasDesvinculadas?.length && updated.idCompra) {
          this.recarregarNotasLiberadas([updated.idCompra]);
        }
      });
    };

    if (card.idCompra) {
      this.loadingCardKeys.add(openKey);
      // Carrega detalhe + obrigatoriedade dos campos nativos da etapa em paralelo,
      // para o dialog já abrir com o "*" correto (sem flash).
      const stage = this.allStages.find(s => s.key === card.stage);
      const config$ = stage?.idEtapaKanban
        ? this.etapasKanbanService.getCamposNativos(stage.idEtapaKanban)
        : of(null);
      forkJoin({
        // Quem abre o card pelo link do histórico já trouxe o detalhe para montá-lo.
        detalhe: detalhePreCarregado ? of(detalhePreCarregado) : this.compraService.getDetalhe(card.idCompra),
        config: config$,
      }).pipe(
        // Garante que o spinner do botão de ações sempre libere, mesmo se o
        // corpo da resposta vier malformado e o processamento abaixo lançar
        // antes de chegar em abrir() — sem isso o ícone fica preso girando.
        finalize(() => releaseLoading()),
      ).subscribe({
        next: ({ detalhe, config }) => {
          const nativosObrigatorios = (config && !config.isError)
            ? (config.camposNativos ?? []).filter(c => c.isObrigatorio).map(c => c.idCampoNativo)
            : [];
          if (detalhe?.isError) {
            this.alertService.show('Erro', detalhe.errorDescription || 'Não foi possível carregar os detalhes da compra.', AlertType.error);
          }
          if (config?.isError) {
            this.alertService.show('Erro',
              config.errorDescription || 'Não foi possível carregar os campos obrigatórios da etapa.', AlertType.error);
          }
          abrir(detalhe?.isError ? undefined : detalhe, nativosObrigatorios);
        },
        error: () => {
          this.alertService.show('Erro', 'Não foi possível carregar os detalhes da compra.', AlertType.error);
          abrir();
        },
      });
    } else {
      abrir();
    }
  }

  /**
   * Abre uma compra citada no histórico de outra. O card pode não estar no quadro — é o caso da
   * cotação arquivada —, então ele é montado a partir do detalhe em vez de procurado em cardsByStage.
   */
  private abrirCompraPorId(idCompra: number, nota?: CardNotaContexto): void {
    if (!idCompra) return;

    const noQuadro = this.allStages
      .flatMap(s => this.cardsByStage[s.key] || [])
      .find(c => c.idCompra === idCompra);
    if (noQuadro) {
      this.openCard(noQuadro, undefined, nota);
      return;
    }

    this.compraService.getDetalhe(idCompra).subscribe({
      next: (res) => {
        const compra = res?.isError ? undefined : res?.compra;
        if (!compra) {
          this.alertService.show('Atenção', 'Não foi possível abrir a compra.', AlertType.warning);
          return;
        }
        // Etapa inativa não vem em allStages: sem a chave o card abriria rotulado com a primeira
        // etapa do fluxo e sem o conteúdo da etapa real.
        const etapa = this.allStages.find(s => s.idEtapaKanban === compra.idEtapaKanban);
        if (!etapa) {
          this.alertService.show('Atenção',
            'A etapa desta compra está inativa. Reative a etapa para abrir o card.', AlertType.warning);
          return;
        }
        this.openCard(this.mapCard({
          idCompra: compra.idCompra,
          codigo: compra.codigo,
          titulo: compra.titulo,
          chaveEtapa: etapa.key,
          idTipoPrioridade: compra.idTipoPrioridade,
          idUsuarioResponsavel: compra.idUsuarioResponsavel,
          valorTotal: compra.valorTotal,
          datetimeInclusao: compra.datetimeInclusao || new Date().toISOString(),
          isAprovado: !!compra.isAprovado,
          idFornecedor: compra.idFornecedor,
          qtdFornecedores: compra.idFornecedor ? 1 : 0,
          qtdFornecedoresResponderam: 0,
          idStatusConferenciaVolumes: null,
          idStatusConferenciaItens: null,
          quantidadeProblemasConferencia: 0,
          quantidadeDivergenciasConferencia: 0,
          isEstoqueLancado: !!compra.isEstoqueLancado,
          isFinanceiroLancado: !!compra.isFinanceiroLancado,
          idOrigemLancamentoEstoque: compra.idOrigemLancamentoEstoque ?? null,
          idOrigemLancamentoFinanceiro: compra.idOrigemLancamentoFinanceiro ?? null,
          isSemNotaFiscal: !!compra.isSemNotaFiscal,
        }), res, nota);
      },
      error: () => this.alertService.show('Erro', 'Não foi possível abrir a compra.', AlertType.error),
    });
  }

  private getCardOpenKey(card: KanbanCard): string {
    return card.idCompra ? `compra:${card.idCompra}` : `card:${card.id}`;
  }

  private suppressProgrammaticCardAnimation(): void {
    this.suppressCardMoveAnimation = true;
    setTimeout(() => {
      this.suppressCardMoveAnimation = false;
    }, 180);
  }

  limparFiltros(): void {
    this.filterModel.patchValue(
      { searchText: '', filterRespId: null, filterPrio: '', filterStage: '', filterStatus: '' },
      { emitEvent: false },
    );
    this.aplicarFiltros();
  }

  aplicarFiltros(): void {
    this.snapshotFiltros();
    this.recarregarKanban();
    this.invalidarLista();
  }

  private snapshotFiltros(): void {
    const { searchText, filterRespId, filterPrio, filterStage, filterStatus } = this.filterModel.value;
    this.appliedFilters = {
      searchText: (searchText ?? '').trim(),
      filterRespId: filterRespId ?? null,
      filterPrio: filterPrio ?? '',
      filterStage: filterStage ?? '',
      filterStatus: filterStatus ?? '',
    };
  }

  abrirGaveta(): void {
    this.gavetaAberta = true;
  }

  fecharGaveta(): void {
    this.gavetaAberta = false;
  }

  onGavetaTotalChange(total: number): void {
    this.gavetaTotal = total;
  }

  /** Concluiu o vínculo (nota → Pedido Faturado ou Divergência): mesmo recarregamento de outras mutações. */
  onGavetaVinculado(): void {
    this.recarregarKanban();
    this.invalidarLista();
  }

  /**
   * Moldura da NF: abre no modo NF (nota, pedidos dela e itens) o pedido clicado ou, pelo cabeçalho, o primeiro
   * da nota. A troca entre os pedidos da nota acontece dentro do card.
   */
  abrirNota(grupo: GrupoCardsEtapa, clicado?: KanbanCard): void {
    const cards = grupo.cards.filter(card => !!card.idCompra);
    if (!grupo.idNFeEntrada || !cards.length) {
      if (clicado) this.openCard(clicado);
      return;
    }
    const nota: CardNotaContexto = {
      idNFeEntrada: grupo.idNFeEntrada,
      rotulo: grupo.rotulo,
      pedidos: cards.map(card => ({
        idCompra: card.idCompra!,
        codigo: card.id,
        nomeEtapa: this.getStage(card.stage).name,
        valorLabel: this.cardValueLabel(card.value),
        nomeFornecedor: this.nomeFornecedor(card),
      })),
    };
    this.openCard(clicado?.idCompra ? clicado : cards[0], undefined, nota);
  }

  /**
   * Botão "Gerenciar vínculo da nota" da moldura: abre o modal de vínculo com a nota inteira (todos os pedidos
   * vinculados), no mesmo fluxo do `ced-stage-nota.abrirVinculo` — trava após lançamento, associação
   * de itens pendente e, ao concluir, recarga do quadro e da gaveta (Trocar NF devolve a nota anterior).
   */
  async gerenciarVinculoNota(idNFeEntrada: number | null): Promise<void> {
    if (!idNFeEntrada || !this.podeGerenciarVinculoNota || this.gerenciandoNotaId !== null) return;
    this.gerenciandoNotaId = idNFeEntrada;
    try {
      const trava = await firstValueFrom(this.notaFiscalEntradaService.consultarEdicaoVinculo(idNFeEntrada));
      if (trava.isError) {
        this.alertService.show('Atenção', trava.errorDescription || 'O vínculo desta nota não pode ser alterado.', AlertType.warning);
        return;
      }

      // A nota inteira: todos os pedidos já vinculados entram e têm os vínculos substituídos.
      const vinculado = await this.vinculoNotaPedidoFluxo.executar(idNFeEntrada, contexto => ({
        idsCompra: contexto.vinculosPedido.map(v => v.idCompra),
        idsVinculoSubstituir: contexto.vinculosPedido.map(v => v.idCompraNFeEntradaVinculo),
      }));
      if (!vinculado) return;
      this.onGavetaVinculado();
      // A gaveta fica montada mesmo fechada e alimenta o contador do botão: recarrega sempre.
      this.gaveta?.recarregar();
    } catch (e) {
      this.alertService.show('Gerenciar vínculo da nota',
        e instanceof Error && e.message ? e.message : 'Não foi possível abrir o vínculo da nota.', AlertType.error);
    } finally {
      this.gerenciandoNotaId = null;
    }
  }

  openNovasolicitacao(): void {
    const ref = this.dialog.open(NovaSolicitacaoDialogComponent, {
      autoFocus: false,
      width: '790px',
      maxWidth: '96vw',
      maxHeight: '92vh',
      disableClose: true,
    });

    ref.afterClosed().subscribe((result) => {
      if (!result?.compra) return;
      const compra = result.compra;
      const stage = result.chaveEtapa || this.mainStages[0]?.key || this.allStages[0]?.key || '';
      if (!stage) return;
      const now = new Date();
      const dialPessoa = result.responsavelPessoa;
      const mapPessoa = compra.idUsuarioResponsavel ? this.usersById.get(compra.idUsuarioResponsavel) : undefined;
      const pessoa = mapPessoa || dialPessoa;
      const card: KanbanCard = {
        id: formatCodigoCompra(compra.codigo),
        idCompra: compra.idCompra,
        idUsuarioResponsavel: compra.idUsuarioResponsavel,
        stage,
        title: compra.titulo ?? '',
        value: formatKanbanCardValue(compra.valorTotal),
        prio: PRIO_POR_ID[compra.idTipoPrioridade] || 'media',
        resp: pessoa?.initials || '',
        respName: pessoa?.name,
        respColor: pessoa?.color,
        date: now.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }),
      };
      if (!this.cardsByStage[stage]) this.cardsByStage[stage] = [];
      this.cardsByStage[stage] = [card, ...this.cardsByStage[stage]];
      this.reconciliarMutacao([stage]);
    });
  }
}
